

export const Mandatory = ({ mandatory, colorVal = "red", fontSize = "75%", top = "0" }) => {
    if (mandatory) {
        return <sup style={{ color: colorVal, marginLeft: "4px", fontSize, top }}>*</sup>;
    }
    return null;
};